import { createGlobalStyle } from 'styled-components';

const ErrorStyles = createGlobalStyle`

.error-container .container-fluid {
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.error-page .error-container .main-content {
  flex: 1;
  margin-top: -32px;
  padding: 0px 20px 0px;
  background: radial-gradient(
    101.47% 46.86% at 50% 50%,
    #ffdada 0%,
    #ffffff 100%
  );
  overflow: hidden;
  padding-bottom: 136px;
}

.error-page .error-container .main-content .icon-wp {
  width: 100%;
  height: auto;
  margin: auto;
}

.error-page .error-container .main-content .icon-wp img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.error-page .error-container .main-content .message {
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #ffffff;
  box-shadow: 0px 12px 12px rgba(255, 0, 0, 0.04);
  backdrop-filter: blur(6px);
  border-radius: 16px;
  padding: 32px;
  width: fit-content;
  margin: auto;
  margin-top: -80px;
  text-align: center;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #6f7072;
}

.error-page .error-container .main-content .message .title {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #f3313a;
  margin-bottom: 12px;
}
.error-page .error-container .main-content .btns-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin: auto;
  margin-top: 46px;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  max-width: unset;
  padding: 20px;
}
.error-page .error-container .main-content .btns-section > * {
  flex: 1;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-decoration: none;
  padding: 12px 20px;
}

.error-page .error-container .main-content .btns-section button a,
.success-page .success-container .main-content .btns-section button a:hover,
.error-page .error-container .main-content .btns-section button a:active:focus {
  border: none;
  background: transparent;
  color: inherit;
  text-decoration: none;
  padding: 0px;
  margin: auto;
  display: block;
  width: 100%;
  height: 100%;
}

@media screen and (min-width: 576px) {
  .error-page .error-container .main-content .icon-wp {
    max-width: 466px;
  }
  .error-page .error-container .main-content .message {
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #ffffff;
    box-shadow: 0px 12px 12px rgba(255, 0, 0, 0.04);
    backdrop-filter: blur(6px);
    border-radius: 16px;
    padding: 32px;
    width: fit-content;
    margin: auto;
    margin-top: -70px;
    text-align: center;
    font-weight: 300;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: #6f7072;
  }

  .error-page .error-container .main-content .message .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 36px;
    text-align: center;
    color: #f3313a;
    margin-bottom: 12px;
  }
  .error-page .error-container .main-content .btns-section {
  }
  .error-page .error-container .main-content .btns-section button a {
    border: none;
    background: transparent;
    color: inherit;
    text-decoration: none;
    padding: 0px;
    margin: auto;
    display: block;
    width: 100%;
    height: 100%;
  }
}

@media screen and (min-width: 769px) {
  .error-container .container-fluid {
    min-height: calc(100% - 60px);
  }
  .error-page .error-container .main-content {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.02), 0px 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 32px 32px 0px 0px;
    padding: 24px;
    overflow: hidden;
    margin-top: 32px;
  }

  .error-page .error-container .main-content .icon-wp {
    width: 466px;
    height: 466px;
    margin: auto;
    margin-top: -100px;
  }

  .error-page .error-container .main-content .icon-wp img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .error-page .error-container .main-content .message {
    margin-top: -65px;
  }

  .error-page .error-container .main-content .message .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 36px;
    text-align: center;
    color: #f3313a;
    margin-bottom: 12px;
  }
  .error-page .error-container .main-content .btns-section {
    position: relative;
  }
  .error-page .error-container .main-content .btns-section > * {
    flex: 1;
  }
}
@media screen and (max-width: 768px) {
  .error-container .container-fluid {
    padding: 0;
  }

  /* Style::Error message that could not connect to server or response error code 500 */
  .permission-popup-container.box-content .content {
    text-align: center;
  }

}

@media screen and (max-width: 320px) {
  .error-page .error-container .main-content .btns-section > button,
  .error-page .error-container .main-content .btns-section > a {
    padding: 12px 6px;
  }
}

`;

export default ErrorStyles;
